import { Component, Input } from "@angular/core";
import { NgbAccordion } from "@ng-bootstrap/ng-bootstrap/accordion/accordion";

@Component({
  selector: "app-custom-accordion",
  templateUrl: "./custom-accordion.component.html"
})
export class CustomAccordionComponent extends NgbAccordion {
  @Input() arrowExpand = true;
}



// WEBPACK FOOTER //
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/components/custom-accordion/custom-accordion.component.ts